import { CustomWidgetStyles } from './addi-product-widget.d';
import {
  ColorAddiGrayLighten3,
  ColorAddiFontPrimary,
  ColorAddiBackgroundWhite,
  ColorAddiCompThreeLighten1,
  ColorAddiPrimaryActive,
  ColorAddiCompFiveBase,
  ColorAddiFontOverDark,
} from '@addi/ds-legacy/util-tokens/pkg';
import {
  FontAddiFamilyPrimaryName,
  FontAddiFamilySecondaryName,
} from '@addi/ds-legacy/util-tokens/pkg';

export const DEFAULT_WIDGET_STYLES: CustomWidgetStyles = {
  widget: {
    borderColor: ColorAddiGrayLighten3,
    borderRadius: '5px',
    fontColor: ColorAddiFontPrimary,
    fontFamily: `${FontAddiFamilySecondaryName}, system-ui`,
    fontSize: '12px',
    badgeBackgroundColor: ColorAddiBackgroundWhite,
    infoBackgroundColor: ColorAddiBackgroundWhite,
    iconType: 'filled',
    iconSize: '28px',
    margin: '0 0 10px 0',
  },
  modal: {
    backgroundColor: ColorAddiBackgroundWhite,
    fontColor: ColorAddiFontPrimary,
    fontFamily: FontAddiFamilyPrimaryName,
    priceColor: ColorAddiCompFiveBase,
    badgeBorderRadius: '5px',
    badgeBackgroundColor: ColorAddiCompThreeLighten1,
    badgeFontColor: ColorAddiFontOverDark,
    cardColor: ColorAddiBackgroundWhite,
    buttonBorderColor: ColorAddiPrimaryActive,
    buttonBorderRadius: '24px',
    buttonBackgroundColor: ColorAddiPrimaryActive,
    buttonFontColor: ColorAddiFontOverDark,
  },
};
